import { NavigationGuard } from 'vue-router'
import UserBus from '@/utils/buses/UserBus'

/**
 * determines if user can navigate to login page or is redirected to landing page
 * @param to
 * @param from
 * @param next
 */
export const loginGuard: NavigationGuard = (to, from, next) => {
  if (UserBus.user) {
    // if user is logged in, re-direct to landing page
    next({
      name: 'designers'
    })
  } else {
    // else continue to login page
    next()
  }
}

/**
 * determines if user can navigated to authenticated page or is redirect to login page
 * @param to
 * @param from
 * @param next
 */
export const authGuard: NavigationGuard = (to, from, next) => {
  if (UserBus.user) {
    // if user is logged in, continue to page
    next()
  } else {
    // else re-direct to login page
    next({
      name: 'login'
    })
  }
}
